import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Lock, UserPlus, LogIn, ShieldCheck } from 'lucide-react';
import { useLang } from '@/context/LanguageContext';

export const AssessmentGate = ({ isAdmin }) => {
  const { t } = useLang();
  return (
    <div className="pt-20 min-h-screen flex items-center" data-testid="assessment-gate">
      <div className="max-w-xl mx-auto px-6 py-24 w-full text-center">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
          <div className="w-16 h-16 rounded-full border border-[rgba(212,175,55,0.3)] bg-[#D4AF37]/10 flex items-center justify-center mx-auto mb-8">
            {isAdmin ? <ShieldCheck className="w-7 h-7 text-[#D4AF37]" strokeWidth={1.5} /> : <Lock className="w-7 h-7 text-[#D4AF37]" strokeWidth={1.5} />}
          </div>
          <p className="overline mb-4">{t('q.overline')}</p>
          <h1 className="text-4xl lg:text-5xl font-['Cormorant_Garamond'] font-bold text-[#F5F2EB] mb-5">
            {isAdmin ? t('gate.admin_title') : t('gate.title')}
          </h1>
          <p className="text-[#A3A19C] leading-relaxed mb-10">{isAdmin ? t('gate.admin_sub') : t('gate.sub')}</p>
          {isAdmin ? (
            <Link to="/admin" className="btn-primary inline-flex items-center gap-2" data-testid="gate-admin-btn">{t('nav.admin_panel')}</Link>
          ) : (
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/register?redirect=questionnaire" className="btn-primary inline-flex items-center justify-center gap-2" data-testid="gate-register-btn">
                <UserPlus className="w-4 h-4" strokeWidth={1.5} /> {t('auth.create')}
              </Link>
              <Link to="/login?redirect=questionnaire" className="btn-secondary inline-flex items-center justify-center gap-2" data-testid="gate-login-btn">
                <LogIn className="w-4 h-4" strokeWidth={1.5} /> {t('auth.signin')}
              </Link>
            </div>
          )}
          {!isAdmin && (
            <ul className="mt-12 space-y-3 text-sm text-[#A3A19C] text-start max-w-sm mx-auto">
              {['gate.b1', 'gate.b2', 'gate.b3'].map(k => (
                <li key={k} className="flex items-start gap-3">
                  <span className="w-1.5 h-1.5 rotate-45 bg-[#D4AF37] mt-2 flex-shrink-0" />{t(k)}
                </li>
              ))}
            </ul>
          )}
        </motion.div>
      </div>
    </div>
  );
};
